import React from 'react';
import { HelpCircle } from 'lucide-react';
import { CustomTooltip } from '../CustomTooltip';

interface AdvisorFieldProps {
  label: string;
  children: React.ReactNode;
  description?: string;
  className?: string;
  tooltip?: React.ReactNode;
}

export const AdvisorField = ({
  label,
  children,
  description,
  className = '',
  tooltip,
}: AdvisorFieldProps) => {
  return (
    <div className={`sm:col-span-6 ${className}`}>
      <label className="block text-sm font-medium leading-6 text-gray-900">
        <div className="flex items-center gap-1">
          {label}
          {tooltip && (
            <CustomTooltip content={tooltip}>
              <HelpCircle className="h-5 w-5 pb-1 text-gray-500" />
            </CustomTooltip>
          )}
        </div>
      </label>
      {description && <p className="mt-1 text-sm text-gray-700">{description}</p>}
      <div className="mt-2">{children}</div>
    </div>
  );
};
